import { AssetPrefixes } from './AssetPrefixes';

export default AssetPrefixes;
